
import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Button } from "../ui/button";
import { Check, ArrowRight } from 'lucide-react';

export function PricingSection() {
  return (
    <section className="py-20 bg-gradient-to-br from-white to-[#E6E6FA]/50">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
              Simple, Transparent Pricing
            </h2>
            <p className="text-lg text-gray-600 mb-6">
              Everything you need to transform your sleep coaching practice
            </p>
          </motion.div>
        </div>

        <div className="max-w-lg mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="bg-white rounded-2xl shadow-xl overflow-hidden border border-[#E6E6FA]"
          >
            {/* Pricing header */}
            <div className="bg-[#6A5ACD] p-6 text-center">
              <h3 className="text-2xl font-bold text-white mb-2">Professional Plan</h3>
              <div className="flex items-center justify-center">
                <span className="text-[#E6E6FA] text-xl mr-2">$</span>
                <span className="text-5xl font-bold text-white">27</span>
                <span className="text-[#E6E6FA] ml-2">/month</span>
              </div>
              <p className="text-[#E6E6FA] mt-2">
                Billed monthly. Cancel anytime.
              </p>
            </div>

            {/* Features list */}
            <div className="p-6">
              <ul className="space-y-4">
                <li className="flex items-start">
                  <Check className="h-5 w-5 text-[#6A5ACD] mr-3 mt-0.5 flex-shrink-0" />
                  <span className="text-gray-700">AI-powered sleep analysis for all clients</span>
                </li>
                <li className="flex items-start">
                  <Check className="h-5 w-5 text-[#6A5ACD] mr-3 mt-0.5 flex-shrink-0" />
                  <span className="text-gray-700">Real-time sleep tracking and notifications</span>
                </li>
                <li className="flex items-start">
                  <Check className="h-5 w-5 text-[#6A5ACD] mr-3 mt-0.5 flex-shrink-0" />
                  <span className="text-gray-700">Unlimited families and children</span>
                </li>
                <li className="flex items-start">
                  <Check className="h-5 w-5 text-[#6A5ACD] mr-3 mt-0.5 flex-shrink-0" />
                  <span className="text-gray-700">Client management dashboard</span>
                </li>
                <li className="flex items-start">
                  <Check className="h-5 w-5 text-[#6A5ACD] mr-3 mt-0.5 flex-shrink-0" />
                  <span className="text-gray-700">In-app messaging with clients</span>
                </li>
                <li className="flex items-start">
                  <Check className="h-5 w-5 text-[#6A5ACD] mr-3 mt-0.5 flex-shrink-0" />
                  <span className="text-gray-700">White-label client portal</span>
                </li>
                <li className="flex items-start">
                  <Check className="h-5 w-5 text-[#6A5ACD] mr-3 mt-0.5 flex-shrink-0" />
                  <span className="text-gray-700">Export reports and analytics</span>
                </li>
              </ul>

              <div className="mt-8">
                <Button 
                  size="lg" 
                  className="w-full bg-[#6A5ACD] hover:bg-[#574AB4] text-white py-6 h-auto text-lg rounded-xl flex items-center justify-center gap-2"
                  asChild
                >
                  <Link to="/specialist-registration">
                    Start Your 14-Day Free Trial <ArrowRight className="h-5 w-5 ml-1" />
                  </Link>
                </Button>
                <p className="text-center text-gray-500 text-sm mt-4">
                  No credit card required to start your trial
                </p>
              </div>
            </div>
          </motion.div>

          {/* Testimonial or guarantee */}
          <div className="mt-8 text-center">
            <p className="text-gray-600 italic">
              "SleepNest has transformed my coaching business. It's worth every penny!"
            </p>
            <p className="text-gray-800 font-medium mt-2">
              — Sarah Johnson, Certified Sleep Specialist
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
